module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "toc_marker-2"
    }
  }, [_vm._v("The Biblical"), _c('br'), _vm._v("\n  Imagination")]), _vm._v(" "), _c('p', [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "initial-cap"
  }, [_vm._v("T")]), _vm._v("his is the third volume in the Biblical Imagination Series. The first two examined the Gospels of Luke and Mark. Our approach is to “engage the text at the level of the informed imagination.” This method takes seriously the impact of the fall on every dimension of human experience, including the fragmented and fallen way we listen to the Bible.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("On one side are those who study Scripture with their minds. They engage intellectually, puzzling over the text as if it were only a cipher to be solved. They tend to gravitate toward theology. They revel in being “right.” On the other side are those who engage the Bible predominately with the heart. They lean toward the emotional, even mystical understanding of the Scripture. Rather than theological, I would describe them as devotional in their approach. Neither approach is wrong, but both are incomplete. God has given us hearts with which to feel and minds for reasoning. He longs to recapture them both with the truth of the Word.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“"), _c('em', {
    staticClass: "i"
  }, [_vm._v("Listen")]), _vm._v(", Israel: The "), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("LORD")]), _vm._v(" our God, the "), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("LORD")]), _vm._v(" is One. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Love")]), _vm._v(" the "), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("LORD")]), _vm._v(" your God with all your heart, with all your soul, and with all your strength.” When the Shema (Deut 6:4-5) calls us to “hear” or “listen,” it goes on to say that we are to love the Lord our God with all that we are—all our heart, soul and strength.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("“"), _c('em', {
    staticClass: "i"
  }, [_vm._v("Listen")]), _vm._v(", Israel: the "), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("LORD")]), _vm._v(" our God, the Lord is One. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Love")]), _vm._v(" the "), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("LORD")]), _vm._v(" your God.” Listening and loving—these two imperatives demand that we learn to engage the Scriptures with all we can muster, for to listen to God is at the same moment to love him.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("How do we reconnect this rift between the heart and mind that was caused by the fall? As I understand it, only the imagination can bridge the gap. This is why the Bible reaches out primarily to our imaginations, for by doing so, the heart and mind become reengaged. We hear the poetry of the Psalms or the music of the Prophets, we listen to the parables of Jesus. As we do, the recaptured imagination engages both heart and mind. Our listening becomes an expression of love. We are made whole and the Living Word comes to life in us.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Imagine the possibilities if we could bring more of ourselves to the task of listening to the Bible. How many new connections might be made, and how many new insights might come to the surface, all as a result of loving God by listening to him with all that we are—all our hearts and all our minds.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95a66ce0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Preface.vue
// module id = 66
// module chunks = 0